import React, { useContext, useEffect, useState } from 'react';
import { Box, Button, Radio, RadioGroup, Stack } from '@mui/material';
import { toast } from 'react-toastify';
import Toast from '../../../../components/Toast';
import { options } from '../../../../helpers/toastOptions';
import { useModal } from '../../../../hooks/Modal';
import { ReverseCollectContext } from '../..';
import { ModalTitle } from './styled';

export const ModalChangeCollectAddress = () => {
  const [radio, setRadio] = useState('');

  const { closeModal, Modal } = useModal();

  const {
    addressSenderList,
    selectedAddressSenderIndex,
    setSelectedAddressSenderIndex,
    setCollectSenderData,
    openAddCollectAddressModal
  } = useContext(ReverseCollectContext);

  const handleChangeRadio = (event) => {
    setRadio(event.target.value);
  };

  const handleSetAddress = () => {
    const index = parseInt(radio.replace('address', ''), 10);

    const hasInvalidAddressSelected =
      !addressSenderList[index]?.name ||
      !addressSenderList[index]?.document ||
      !addressSenderList[index]?.address?.zipPostalCode ||
      !addressSenderList[index]?.address?.streetAddress ||
      !addressSenderList[index]?.address?.streetAddressNumber ||
      !addressSenderList[index]?.address?.suburb ||
      !addressSenderList[index]?.address?.city ||
      !addressSenderList[index]?.address?.state;

    if (hasInvalidAddressSelected) {
      toast(
        <Toast
          title="Atenção!"
          content="Selecione um endereço que contenha todas informações obrigatórias."
          type="error"
        />,
        options
      );

      return;
    }

    setCollectSenderData(addressSenderList[index]);
    setSelectedAddressSenderIndex(index);
    closeModal();
  };

  const handleCloseModal = () => {
    closeModal();
  };

  useEffect(() => {
    setRadio(`address${selectedAddressSenderIndex}`);
  }, []);

  return (
    <Modal>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16,
          padding: '0 16px',
          margin: '0 -8px',
          maxHeight: '86vh',
          overflow: 'auto'
        }}
      >
        <ModalTitle>ENDEREÇO DE COLETA</ModalTitle>

        <RadioGroup defaultValue="address1" name="collectAddress">
          <Stack spacing={3}>
            {addressSenderList.map((addressSender, index) => (
              <Stack
                // eslint-disable-next-line react/no-array-index-key
                key={`address${index}`}
                direction="row"
                spacing={2}
                alignItems="center"
              >
                <Radio
                  name="collectAddress"
                  id={`address${index}`}
                  value={`address${index}`}
                  disabled={
                    !addressSender.name ||
                    !addressSender.document ||
                    !addressSender?.address?.zipPostalCode ||
                    !addressSender?.address?.streetAddress ||
                    !addressSender?.address?.streetAddressNumber ||
                    !addressSender?.address?.suburb ||
                    !addressSender?.address?.city ||
                    !addressSender?.address?.state
                  }
                  checked={radio === `address${index}`}
                  onChange={handleChangeRadio}
                />
                <label
                  htmlFor={`address${index}`}
                  style={{
                    cursor:
                      !addressSender.name ||
                      !addressSender.document ||
                      !addressSender?.address?.zipPostalCode ||
                      !addressSender?.address?.streetAddress ||
                      !addressSender?.address?.streetAddressNumber ||
                      !addressSender?.address?.suburb ||
                      !addressSender?.address?.city ||
                      !addressSender?.address?.state
                        ? 'default'
                        : 'pointer'
                  }}
                >
                  <p>
                    {addressSender?.name} - {addressSender?.document}
                  </p>
                  <p>
                    CEP: {addressSender?.address?.zipPostalCode},{' '}
                    {addressSender?.address?.streetAddress}
                    {addressSender?.address?.streetAddressNumber &&
                      `, ${addressSender?.address?.streetAddressNumber}`}
                    {addressSender?.address?.additionalInformation &&
                      `, ${addressSender?.address?.additionalInformation}`}
                    {addressSender?.address?.suburb &&
                      `, ${addressSender?.address?.suburb}`}
                    {addressSender?.address?.city &&
                      `, ${addressSender?.address?.city}`}
                    {addressSender?.address?.state &&
                      `-${addressSender?.address?.state}`}
                  </p>
                </label>
              </Stack>
            ))}
          </Stack>
        </RadioGroup>

        <Button type="button" onClick={openAddCollectAddressModal}>
          Adicionar novo endereço
        </Button>

        <Stack direction="row" spacing={2} marginTop={1}>
          <Button
            type="button"
            variant="contained"
            color="secondary"
            onClick={handleCloseModal}
          >
            Cancelar
          </Button>
          <Button type="button" variant="contained" onClick={handleSetAddress}>
            Confirmar
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};
